export enum BirthdayState {
  ModalLoading = 'modalLoading',
  ModalLoaded = 'modalLoaded',
  UpdatingBirthday = 'updatingBirthday',
  SuccessToastVisible = 'successToastVisible',
  ErrorToastVisible = 'errorToastVisible',
}
